define('modules/common/service/DatiCliente',[], function() {
    var DatiCliente = function($http, $q, PATH, Token, Studio, LoadingHandler) {

        var dati = false;

        var load = function() {
            LoadingHandler.start();
            $http.defaults.headers.common['Authorization'] = 'TOKEN:' + Token.get();
            var deferred = $q.defer();

            Studio.getId().then(function(id) {
                $http({
                    method: 'GET',
                    url: 'https://' + PATH.ENTRYPOINT + '/' + id + '/daticliente',
                    cache: false
                }).then(
                    function(response) {
                        dati = response.data;
                        deferred.resolve();
                        LoadingHandler.stop();
                    },
                    function(error) {
                        deferred.reject({
                            status: error.status,
                            data: error.data
                        });
                        LoadingHandler.stop();
                    });
            }, function(error) {
                deferred.reject({
                    status: error.status,
                    data: error.data
                });
                LoadingHandler.stop();
            });

            return deferred.promise;

        };

        var reset = function() {
            dati = false;
        };

        var execAfterContentIsLoaded = function() {
            var deferred = $q.defer();
            if (dati) {
                deferred.resolve();
            } else {
                load().then(function() {
                    deferred.resolve();
                }, function(error) {
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        };

        var estraiDenominazione = function() {
            objDenom = dati.denominazione;
            if (objDenom.personafisica) {
                return objDenom.nome + " " + objDenom.cognome;
            } else {
                return objDenom.denominazione;
            }
        };

        var estraiRecapito = function() {
            objRecapito = dati.recapitoprincipale;
            var recapito = [];

            if (objRecapito.persona) {
                recapito.push(objRecapito.persona);
            }
            if (objRecapito.via) {
                recapito.push(objRecapito.via);
            }
            if ((objRecapito.citta) || (objRecapito.cap) || (objRecapito.provincia) || (objRecapito.nazione)) {
                recapito.push([
                    objRecapito.cap,
                    objRecapito.citta, ((objRecapito.provincia) ? "(" + objRecapito.provincia + ")" : ""),
                    "- " + objRecapito.nazione
                ].join(" "));
            }
            if (objRecapito.presso) {
                recapito.push("c/o " + objRecapito.presso);
            }

            return recapito.join("<br />");
        };

        return {
            load: load,
            reset: reset,
            getDenominazione: function() {

                return execAfterContentIsLoaded().then(estraiDenominazione);

            },
            getRecapitoPrincipale: function() {

                return execAfterContentIsLoaded().then(estraiRecapito);
            },
            getCodiceFiscale: function() {
                return execAfterContentIsLoaded().then(function() {
                    return dati.codicefiscale;
                });
            },
            getPartitaIva: function() {
                return execAfterContentIsLoaded().then(function() {
                    return dati.partitaiva;
                });
            },
            getNascita: function() {
                return execAfterContentIsLoaded().then(function() {
                    return {
                        luogonascita: dati.luogonascita,
                        datanascita: dati.datanascita
                    };
                });
            },
            canChangePassword: function() {
                return execAfterContentIsLoaded().then(function(){
                    return dati.abilitacambiopassword;
                });
            },
            mustChangePassword: function() {
                return execAfterContentIsLoaded().then(function(){
                    return dati.forzacambiopassword;
                });
            }
        };
    };

    return ["$http", "$q", "PATH", "Token", "Studio", "LoadingHandler", DatiCliente];
});
